import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { type TrpcError, useTRPC } from '@/shared/api';

import type { Video } from '../model/video';

/** 게시된 영상 목록 (챕터·자료 포함, publishedAt 내림차순 — 정렬은 서버를 믿는다). */
export function useVideos(): UseQueryResult<{ items: Video[] }, TrpcError> {
  const trpc = useTRPC();
  return useQuery(trpc.lib.listVideos.queryOptions());
}

/** 영상 상세 — /library/:slug (D7). 없는 slug 는 NOT_FOUND 에러로 온다. */
export function useVideoBySlug(slug: string): UseQueryResult<Video, TrpcError> {
  const trpc = useTRPC();
  return useQuery(trpc.lib.videoBySlug.queryOptions({ slug }));
}
